<template>
  <div class="container">
    <please-wait-modal/>
    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">HelperQ</h1>
                  </div>
                  <div class="form-group">
                    <input type="email" class="form-control form-control-user" v-model="email" id="exampleInputEmail" autocomplete="off" aria-describedby="emailHelp" @keyup="check_key" placeholder="Enter Email Address...">
                  </div>
                  <div class="form-group">
                    <input type="password" class="form-control form-control-user" v-model="password" @keyup="check_key" id="exampleInputPassword" placeholder="Password">
                  </div>
                  <button class="btn btn-primary btn-user btn-block" @click="log_in">
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'

export default{
  components:{
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      email: '',
      password: '',
    }
  },
  created(){
    console.log(sessionStorage.getItem('redirect'))
  },
  methods:{
    check_key(e){
      if(e.keyCode == 13)
        this.log_in()
    },
    async log_in(){
      if(this.email == '')
        this.$toasted.show('Email is empty')
      else if(this.password == '')
        this.$toasted.show('Password is empty')
      else{
        $('#please_wait_modal').modal('show')
        var response = await axios.post(base_url+'/auth/login',{
          email: this.email,
          password: this.password,
        })

        var response_data = response.data
        $('#please_wait_modal').modal('hide')
        if(response_data.status == "success"){
          if(response_data.type_data.name == 'Admin' || response_data.type_data.name == 'Operator'){
            localStorage.setItem('token',response_data.token)
            var redirect = sessionStorage.getItem('redirect') == null ? '/' : sessionStorage.getItem('redirect')
            sessionStorage.removeItem('redirect')
            location.href = redirect
          }
          else
            this.$toasted.show('This user is not authorized to enter web admin')
        }
        else
          this.$toasted.show(response_data.message)
      }
    }
  }
}
</script>
